<!--
  AppHeader 组件 - 全局顶栏
  高度模块化，使用子组件和Composable
-->
<template>
  <header 
    class="app-header" 
    :class="{ 
      'is-scrolled': isScrolled,
      'app-header--solid': !isLandingPage 
    }" 
    role="banner"
  >
    <div class="ah-content">
      <!-- 固定PC端布局 - 移除响应式切换 -->
      <!-- Logo区域 -->
      <Logo />

      <!-- 导航区域 -->
      <Nav :page-list="pageList" />

      <!-- 右侧操作区 -->
      <Actions
        @logout="emit('logout')"
        @theme-toggle="emit('theme-toggle')"
        @open-api-site="emit('open-api-site')"
      />
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useNavigation } from '@/composables/useNavigation'
import { useScrollFlag } from '@/composables/useScrollFlag'

// 子组件导入
import Logo from './Logo.vue'
import Nav from './Nav.vue'
import Actions from './Actions.vue'

const route = useRoute()

// 事件定义
const emit = defineEmits<{
  'theme-toggle': []
  'open-api-site': []
  'logout': []
}>()

const navigation = useNavigation()

// 滚动状态
const isScrolled = useScrollFlag(4)

// 页面列表
const pageList = navigation.visiblePages

// 判断是否是落地页
const isLandingPage = computed(() => route.name === 'landing')

</script>

<style>
/* AppHeader 组件样式 - 使用设计系统变量 */


.app-header {
  position: sticky; /* 改为 sticky 实现横向随动，纵向固定 */
  top: 0;
  /* left: 0; right: 0;  Sticky 不需要左右定位，会自动撑满父容器 */
  width: 100%;
  min-width: fit-content; /* 确保最小宽度一致 */
  height: var(--tts-nav-height);
  background: transparent; /* Layer B: 初始完全透明，展示Global Canvas */
  border-bottom: 1px solid transparent;
  backdrop-filter: none; /* 初始无模糊，提升通透感 */
  z-index: var(--tts-z-fixed);
  transition: all 0.3s ease;
}

/* 滚动后变为玻璃拟态 */
.app-header.is-scrolled {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--tts-border-light);
  box-shadow: var(--tts-shadow-sm);
}

/* 非落地页（工作台等）强制使用纯白背景 - 专业工具模式 */
/* Logic handled by .app-header--solid class above */

/* 更好的方式：利用CSS类名控制 */
.app-header.app-header--solid {
  position: sticky;
  top: 0;
  background: var(--tts-surface-1); /* 纯白背景 */
  border-bottom: 1px solid var(--tts-border-light);
  backdrop-filter: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* 极细微的投影 */
  z-index: var(--tts-z-fixed);
}

.ah-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  min-width: fit-content; /* Ensure content doesn't shrink below minimum size */
  margin: 0 auto;
  padding: 0 var(--tts-space-4);
  padding-right: 22px;
  box-sizing: border-box; /* Explicitly set box-sizing */
}
</style>

